<template>
  <el-dialog
    title="导入"
    :visible.sync="formDialogVisible"
    width="700px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="submitForm('form')">
          保存
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
// import { FormValidators } from '@/utils/validate';

export default {
  props: {
    type: {
      type: String,
      default: '',
    },
    id: {
      type: Number,
      default: 0,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formDialogVisible: false,
      dialogTitle: '',
    };
  },
  created() {
    // this.initFormData();
  },
  watch: {
    // 显示隐藏双向绑定
    visible(val) {
      this.formDialogVisible = val;
      if (val) {
        this.initFormData();
      }
    },
    formDialogVisible(val) {
      this.$emit('visible-change', val);
    },
  },
  methods: {
    handleClose() {
      this.formDialogVisible = false;
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-select,
.el-date-editor {
  width: 100%;
}
</style>
